'use client';

import clsx from 'clsx';
import DynamicCardSection, { type CardItem } from '@/components/section/card/DynamicCardSection';
import { Heading2 } from '@/components/section/headings';

export type CapabilityShowcaseSectionProps = {
  title: string;
  subtitle?: string;
  cards: CardItem[];
  columns?: number;
  className?: string;
};

/**
 * Section heading + glass capability grid (reuses `DynamicCardSection` / `simple-card`).
 */
const CapabilityShowcaseSection: React.FC<CapabilityShowcaseSectionProps> = ({
  title,
  subtitle,
  cards,
  columns = 3,
  className,
}) => {
  return (
    <div className={clsx(className)}>
      <div className="container-section !min-h-0 !pb-8 !pt-10 sm:!pt-12">
        <div className="page-heading-wrap">
          <Heading2
            title={title}
            subtitle={subtitle}
            titleClassName="text-prose"
            subtitleClassName="mt-3 text-prose-muted"
          />
        </div>
      </div>
      <DynamicCardSection cards={cards} columns={columns} className="!pt-0 !min-h-0" />
    </div>
  );
};

export default CapabilityShowcaseSection;
